import { userAPIUrls } from "../common/apiActions";
import { fetch as http } from "./http";

export const fetchUsersService = async (
  { type = 0 }: { type: 0 | 1 } = { type: 0 },
) => {
  try {
    const data = await http.Get(`${userAPIUrls?.getAgents}?type=${type}`);
    return data;
  } catch (error: any) {
    throw error;
  }
};

export const fetchAllUsersService = async (
  { type = 0 }: { type: 0 | 1 } = { type: 0 },
) => {
  try {
    const data = await http.Get(`${userAPIUrls?.getUsers}?type=${type}`);
    return data;
  } catch (error: any) {
    throw error;
  }
};

export const fetchUsersAgentsService = async () => {
  try {
    const data = await http.Get(`${userAPIUrls?.getAgents}`);
    return data;
  } catch (error: any) {
    throw error;
  }
};

export const fetchUsersAgentManagersService = async () => {
  try {
    const data = await http.Get(`${userAPIUrls?.getAgentManagers}`);
    return data;
  } catch (error: any) {
    throw error;
  }
};

export const fetchLocationBaseAgentsService = async () => {
  try {
    const data = await http.Get(`${userAPIUrls?.getLocationBaseAgents}`);
    return data;
  } catch (error: any) {
    throw error;
  }
};

export const createUserService = async (payload: any) => {
  try {
    const data = await http.Post(userAPIUrls?.create, payload);
    return data;
  } catch (error: any) {
    payload?.callback && payload?.callback(true);
    delete payload?.callback;
    throw new Error(error);
  }
};

export const updateUserService = async (payload: any) => {
  try {
    const data = await http.Post(userAPIUrls?.update, payload);
    return data;
  } catch (error: any) {
    payload?.callback && payload?.callback(true);
    delete payload?.callback;
    throw new Error(error);
  }
};
